import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import moment from 'moment';
import LogRow from './LogRow';
import ServiceHeader from './ServiceHeader';
import { DrawerLoading, DrawerEmpty } from './DrawerStates';

function LogsInfo(props) {
  const { getServiceLogs, serviceLogs, loadingServiceLogs, node } = props;
  useEffect(() => {
    getServiceLogs(node.project_id, node.service_name, 20);
  }, []);

  return (
    <Box>
      <ServiceHeader node={node} />
      {loadingServiceLogs ? (
        <DrawerLoading />
      ) : (
        <Box>
          {serviceLogs.logs ? (
            serviceLogs.logs.map((log, idx) => {
              if (log.severity) {
                return <LogRow log={log} />;
              }
            })
          ) : (
            <DrawerEmpty>No logs to show</DrawerEmpty>
          )}
        </Box>
      )}
    </Box>
  );
}

export default LogsInfo;
